/*
 * File: ui-label.ts
 * File Created: 2023-12-18 11:45:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-06 01:55:03
 * Modified By: Val Liu
 * -----
 */

import {
    BaseUITag,
    EUITagRuleType,
    EUITagRuleUnion,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    UITag,
} from "./core";
import { lang } from "@root/core/i18n";

// @uiDefault - replace the original value from `undefined` or `null`,
// into another value.

@UITag.set()
export class uiDefault extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.TableBodyCell, EUITagTarget.FormElement];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Meta];
    allowNullRule: boolean = false;

    /// apply on undefined / null, set props :value
    parse(input: IUITagInput): IUITagResult | null {
        const rule = this.parseRule(input);
        if (rule == null) return null;

        /// only apply `@uiDefault` on `undefined` or `null` value.
        if (input.inputs.props?.value != undefined) return null;

        return {
            props: {
                value: rule == undefined ? rule : lang.translate(rule as string),
            },
        };
    }
}
